<template>
	<div>
		<step-status-component v-if="req && req.status" :status="req.status" :allDeliveryDateOenology="req.allDeliveryDateOenology" :allWineryValid="req.allWineryValid"/>
		<div>
			<card :id="id" :exportXlsx="true" :history="true" :title="'Solicitud de Muestra N°' + id"
				bg="bg-dark text-white" icon="glass-martini" @exportRequest="exportRequest(id)"
				@showHistory="showHistory(id)">
				<template v-slot:titleBadge>
					<management-countdown-badge :deadline="req.dispatchManagementDeadline" :sample-state="req.sampleState" />
				</template>
				<card v-if="req.progressDispatch === 'No' &&
					(req.status === 'Rechazado' || req.status == 'Rechazo_por_calidad')
					" :title="req.status === 'Rechazado'
					? 'Despacho Rechazado' : 'Rechazo por calidad'">
					<div class="table-responsive">
						<div class="card mb-4 bg-danger">
							<div class="card-body">
								<span class="text-white">
									<b>Motivo:</b>
									{{ details[0].rejectionReason }}
								</span>
							</div>
						</div>
					</div>
				</card>
				<div class="row">
					<div class="col-md-4 fixed-column">
						<card class="card cardShadow-light" title="Datos Principales">
							<div class="table-responsive">
								<table class="table table-sm">
									<tr>
										<th style="width: 20%;">Fecha Requerida Despacho</th>
										<td style="width: 30%;">{{ req.requiredDispatchDateString }}</td>
									</tr>
									<tr>
										<th>Unidad de Negocio:</th>
										<td>{{ req.businessUnitName }}</td>
									</tr>
									<tr>
										<th>Centro de Costo:</th>
										<td>{{ req.costCenterName }}</td>
									</tr>
									<tr>
										<th>Despacho Progresivo:</th>
										<td>{{ req.progressDispatch }}</td>
									</tr>
									<tr>
										<th>Objetivo de la Muestra:</th>
										<td>{{ req.sampleTargetName }}</td>
									</tr>
									<tr>
										<th>Detalles de objetivo:</th>
										<td>{{ req.sampleReasonName }}</td>
									</tr>
									<tr>
										<th>Fecha de Envío:</th>
										<td>{{ req.sendedAtString }}</td>
									</tr>								
									<tr>
										<th>Fecha/Hora Límite de Gestión:</th>
										<td>
											<div v-if="(isAdmin || isOenology) && req.sampleState >= 1 && req.sampleState < 6" class="row" style="margin: 0px !important">
												<div class="form-group col-md-7" style="padding: 0px !important; margin-bottom: 0px;">
													<input v-model="managementDeadline" :min="sendedAtLocal" class="form-control form-control-sm" type="datetime-local" />
												</div>
												<div>
													<button class="btn btn-primary btn-sm ml-2" title="Actualizar Fecha/Hora Límite" type="button" @click="updateDeadline">
														<i class="fas fa-save"></i>
													</button>
												</div>
											</div>
											<template v-else>
												<span v-if="req.dispatchManagementDeadlineString">{{ req.dispatchManagementDeadlineString }}</span>
												<span v-else-if="req.sampleState !== 0" class="text-muted" title="Se calcula al enviar la muestra: fecha/hora de envío + 72 horas hábiles (domingo inhábil). Si el envío es a partir de las 16:30, el conteo comienza al día siguiente a las 08:00.">Pendiente de envío</span>
												<span v-else class="text-muted">Sin Registro</span>
											</template>
										</td>
									</tr>
									<tr  v-if="wineryDispatched && req.progressDispatch === 'No'">
										<th>Fecha Despacho total desde Bodega</th>
										<td>{{ req.wineryDispatchDateString }}</td>
									</tr>
								</table>
							</div>
						</card>
						<card class="card mt-2 cardShadow-light" title="Datos de despacho">
							<div class="card">
								<div v-if="existDispatch" class="table-responsive">
									<table class="table table-sm">
										<tr>
											<th>Nombre de Empresa/Cliente:</th>
											<td colspan="3">{{ dispatch.enterpriseName }}</td>
										</tr>
										<tr>
											<th>País</th>
											<td><span v-if="dispatch.country">{{ dispatch.country.name }}</span></td>
											<th>Ciudad:</th>
											<td><span v-if="dispatch.country">{{ dispatch.city.name }}</span></td>
										</tr>
										<tr>
											<th>Código Postal</th>
											<td>{{ dispatch.postalCode }}</td>
											<th>Dirección:</th>
											<td>{{ dispatch.address }}</td>
										</tr>
										<tr>
											<th>Segunda Dirección:</th>
											<td>{{ dispatch.secondAddress }}</td>
											<th>Teléfono:</th>
											<td>{{ dispatch.phoneNumber }}</td>
										</tr>
										<tr>
											<th>Email:</th>
											<td>{{ dispatch.email }}</td>
											<th>Contacto (Sr./Sra.):</th>
											<td>{{ dispatch.contactName }}</td>
										</tr>
										<tr>
											<th>Observaciones:</th>
											<td colspan="3">{{ dispatch.remarks }}</td>
										</tr>
									</table>
								</div>
								<alert v-else message="Aún no se registra Despacho" />
							</div>
						</card>
						<card v-if="(wineryDispatched || send) &&
							req.progressDispatch === 'Si' &&
							anyWineryDispatch
							" class="card cardShadow-light" title="Datos Despacho desde Bodega">
							<div class="table-responsive">
								<table class="table">
									<tr>
										<th>Id</th>
										<th>Tipo de Muestra</th>
										<th>SKU</th>
										<th>Marca</th>
										<th>Mezcla Comercial</th>
										<th>Vino</th>
										<th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
										<th>Fecha Despacho desde Bodega</th>
									</tr>
									<tr v-for="r in requestDetailsWineryDispatch" :key="r.id">
										<td>{{ r.id }}</td>
										<td>{{ r.requestType.name }}</td>
										<td>{{ r.sku }}</td>
										<td>{{ r.brand }}</td>
										<td v-if="r.comercialMixCode">
											{{ r.comercialMixCode }} {{ r.comercialMix }}
										</td>
										<td v-else></td>
										<td>
											{{ r.variety }} {{ r.valley }} {{ r.quality }}
										</td>
										<td>{{ r.finalHarvest }}</td>
										<td>{{ r.wineryDispatchString }}</td>
									</tr>
								</table>
							</div>
						</card>
					</div>
					<div class="col-md-8">
						<div v-if="loadingDetails" class="text-center py-5">
							<div class="spinner-border text-primary" role="status">
								<span class="sr-only">Cargando...</span>
							</div>
							<p class="mt-2 text-muted">Cargando muestras...</p>
						</div>
						<list-detail v-else :id="id" :components="components" :confirmed="confirmed" :details="details"
						:progressDispatch="req.progressDispatch" :request="req" :tracking="tracking" :trackingOne="trackingOne" />
					</div>
				</div>
				<modal id="showHistory" :lg="true" title="Historial de solicitud">
					<history-modal-request :historyOptions="historyOptions"></history-modal-request>
				</modal>
			</card>
		</div>
	</div>
</template>

<script>
import { Get, Put } from "../../../helper/axios.js";
import Card from "../../../components/Card.vue";
import HistoryModalRequest from "@/views/requests/history/HistoryModalRequest.vue";
import $ from "jquery";
import { base64ToArrayBuffer } from '@/helper/fileHelper.js';

export default {
	components: {
		HistoryModalRequest,
		Card
	},
	data() {
		return {
			historyOptions: {
				id: null,
				history: [],
			},
			id: this.$route.params.id,
			apiUrl: this.$store.getters.apiUrl,
			isAdmin: this.$store.getters.isAdmin,
			isCommercial: this.$store.getters.isCommercial,
			isMainCommercial: this.$store.getters.isMainCommercial,
			isDispatcher: this.$store.getters.isDispatcher,
			isOenology: this.$store.getters.isOenology,
			Get,
			Put,
			managementDeadline: "",
			sendedAtLocal: "",
			req: {},
			existDispatch: false,
			loadingDetails: false,
			details: [],
			components: [],
			created: false,
			send: false,
			validWineryDispatch: false,
			wineryDispatched: false,
			validComponents: false,
			validQuality: false,
			dispatched: false,
			confirmed: false,
			tracking: [],
			trackingOne: {},
			validToDispatcher: false,
			requestDetails: [],
			anyWineryDispatch: false,
			invalid: false,
			rejected: false,
			cancelled: false,
			rejectQuality: false,
			partialArrived: false,
		};
	},
	watch: {
		req: {
			deep: true,
			immediate: true,
			handler(newVal) {
				if (newVal && newVal.status) {
					console.log("Nuevo status:", newVal.status);
				}
			}
		}
		},
	created() {
		if (this.id) {
			this.$store.commit("setLoading", true);
			this.Get(this.apiUrl + "v1/requestsamples/" + this.id, (res) => {
				this.req = res.data;
				this.sendedAtLocal = res.data.sendedAt ? res.data.sendedAt.substring(0, 16) : "";
				this.managementDeadline = res.data.dispatchManagementDeadline ? res.data.dispatchManagementDeadline.substring(0, 16) : "";
				if (res.data.status === "Cancelado") {
					this.created = true;
					this.cancelled = true;
				}
				if (res.data.status === "Creado") this.created = true;
				if (res.data.status === "Enviado") {
					this.created = true;
					this.send = true;
				}
				if (res.data.status === "Invalidado") {
					this.created = true;
					this.send = true;
					this.invalid = true;
				}
				if (res.data.status === "En_validacion_de_enologia") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
				}
				if (res.data.status === "Componentes_en_revision") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
				}
				if (res.data.status === "Calidad") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.validToDispatcher = true;
					this.validComponents = true;
				}
				if (res.data.status === "Valido_para_despacho") {
					this.created = true;
					this.send = true;
					this.validComponents = true;
					this.validWineryDispatch = true;
					this.validQuality = true;
				}
				if (res.data.status === "Rechazo_por_calidad") {
					this.created = true;
					this.send = true;
					this.validComponents = true;
					this.validWineryDispatch = true;
					this.rejectQuality = true;
				}
				if (res.data.status === "Rechazado") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.rejected = true;
				}
				if (res.data.status === "Despachado_Bodega") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.wineryDispatched = true;
					this.validComponents = true;
					this.validToDispatcher = true;
					this.validQuality = true;
				}
				if (res.data.status === "Despachado") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.wineryDispatched = true;
					this.dispatched = true;
					this.validComponents = true;
					this.validToDispatcher = true;
					this.validQuality = true;
				}
				if (res.data.status === "Confirmado") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.wineryDispatched = true;
					this.dispatched = true;
					this.confirmed = true;
					this.validQuality = true;
					this.validComponents = true;
					this.validToDispatcher = true;
					this.partialArrived = false;
				}
				if (res.data.status === "Arribado_parcialmente")
				{
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.wineryDispatched = true;
					this.dispatched = true;
					this.confirmed = false;
					this.validQuality = true;
					this.validComponents = true;
					this.validToDispatcher = true;
					this.partialArrived = true;
				}

				this.getTrackings(res.data);
				this.$store.commit("setLoading", false);
			});
			this.$store.commit("setLoading", true);
			this.Get(
				this.apiUrl + "v1/dispatchs?sampleId=" + this.id,
				(res) => {
					this.dispatch = res.data;
					if (this.dispatch)
						this.existDispatch = true;
					this.$store.commit("setLoading", false);
				},
				() => {
					this.existDispatch = false;
				}
			);
		}
		this.getDetails();
		this.getComponents();
	},
	methods: {
		updateDeadline() {
			if (!this.managementDeadline) {
				window.toastr.warning("Debe ingresar la Fecha/Hora Límite de Gestión.");
				return;
			}
			if (this.sendedAtLocal && this.managementDeadline < this.sendedAtLocal) {
				window.toastr.warning("La Fecha/Hora Límite no puede ser anterior a la Fecha de Envío.");
				return;
			}
			this.$swal({
				title: "¿Desea Modificar la Fecha/Hora Límite de Gestión?",
				icon: "info",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
			}).then((result) => {
				if (result.value) {
					this.$store.commit("setLoading", true);
					this.Put(
						this.apiUrl + "v1/dispatchDateRequest/deadline/" + this.id,
						{ dispatchManagementDeadline: this.managementDeadline },
						() => {
							this.$store.commit("setLoading", false);
							window.toastr.success("La Fecha/Hora Límite de Gestión ha sido Modificada correctamente.");
							location.reload();
						}
					);
				}
			});
		},
		getDetails() {
			// includeStock=false: esta vista no usa el stock precalculado (consulta stock on-demand),
			// así se evita el N+1 de GetStock por muestra en el backend.
			this.loadingDetails = true;
			this.Get(`${this.apiUrl}v1/requestsample/${this.id}/details?includeStock=false`, (res) => {
				this.details = res.data;
				res.data.forEach((element) => {
					if (element.wineryDispatch != null) this.anyWineryDispatch = true;
				});
				this.loadingDetails = false;
			}, () => {
				this.loadingDetails = false;
			});
		},
        getComponents() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/selectedComponents/bySampleId/${this.id}`, (res) => {
                this.components = res.data;
                this.$store.commit("setLoading", false);
            });
        },
		getTrackings() {
			this.$store.commit("setLoading", true);
			this.Get(this.apiUrl + "v1/requestdetailtrackings/" + this.id, (res) => {
				this.tracking = res.data;
				this.$store.commit("setLoading", false);
			});

			this.$store.commit("setLoading", true);
			this.Get(this.apiUrl + "v1/trackingssingle/" + this.id, (res) => {
				this.trackingOne = res.data;
				this.$store.commit("setLoading", false);
			});
		},
		showHistory() {
			this.historyOptions.history = this.req.histories;
			$("#showHistory").modal("show");
		},
		exportRequest(id) {
			this.$store.commit("setLoading", true);
			this.Get(this.apiUrl + "v1/exportRequestSample/" + id, (res) => {
				var array = base64ToArrayBuffer(res.data);
				var a = window.document.createElement("a");
				a.href = window.URL.createObjectURL(
					new Blob([array], {
						type: "application/octet-stream",
					})
				);
				a.download = "FCOM " + id + ".xlsx";
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				this.$store.commit("setLoading", false);
			});
		},	
	},
	computed: {
		requestDetailsWineryDispatch() {
			var requestDetailsWineryDispatchList = [];
			this.details.forEach((element) => {
				if (element.wineryDispatch != null)
					requestDetailsWineryDispatchList.push(element);
			});
			return requestDetailsWineryDispatchList;
		},
	},
};
</script>
